import Swiper from 'swiper';

export default function initSwiper () {
  var homeSwiper = new Swiper('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    simulateTouch: false,
    speed: 200,
    delay: 8000,
    loop: true
  })
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/home/swiper.js